import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { NgIf, NgFor } from '@angular/common';

import { OrganizationHierarchy, OrganizationHierarchyChildren, OrganizationHierarchyParent }
	from '../../../models/organization-hierarchy';
import { OrganizationService } from '../../../services/organization.service';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

import { OrgFlowChartElementComponent } from './org-flow-chart-element/org-flow-chart-element.component';

@Component({
	selector: 'copo-organization-flow-chart',
	templateUrl: './org-flow-chart.component.html',
	styleUrl: './org-flow-chart.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		LoadingSpinnerComponent,
		NgIf,
		NgFor,
		OrgFlowChartElementComponent,
	],
})
export class FlowChartComponent implements OnInit, OnDestroy {
	@Input() organizationId?: number;
	@Input() orgIdForflowChart?: number;
	organizationHierarchy?: OrganizationHierarchy;
	organizationFLowChart: OrganizationHierarchyChildren = {
		id: 0,
		name: '',
		children: []
	};

	subscriptions: Subscription;
	root?: number;
	constructor(
		private readonly organizationFlowChartApiService: OrganizationService
	) {
		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		this.root = this.orgIdForflowChart;
		if (this.root) {
			this.fetchOrganizationHierarchy(this.root);
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	setOrganizationFlowChart() {
		if (this.organizationHierarchy?.parent) {
			this.organizationFLowChart.id = this.organizationHierarchy.parent.id;
			this.organizationFLowChart.name = this.organizationHierarchy.parent.name;
		}
		if (this.organizationHierarchy && this.organizationHierarchy.children.length > 0) {
			this.organizationFLowChart.children = this.organizationHierarchy.children;
		}
	}

	getRoot(organization: OrganizationHierarchyParent) {
		if (organization.parent) {
			this.getRoot(organization.parent);
		} else {
			this.root = organization.id;
			if (this.root) {
				this.fetchOrganizationHierarchy(this.root);
			}
		}
	}

	private fetchOrganizationHierarchy(root: number) {
		const organizationHierarchySubscription = this.organizationFlowChartApiService
			.findOrganizationHierarchy(root)
			.subscribe({
				next: (value: OrganizationHierarchy) => {
					this.organizationHierarchy = value;
					if (this.organizationHierarchy.parent) {
						if (!this.organizationHierarchy.parent.parent) {
							this.setOrganizationFlowChart();
						} else {
							this.getRoot(this.organizationHierarchy.parent.parent);
						}
					}
				},
				error: (error: unknown) => {
					console.error(error);
				},
			});

		this.subscriptions.add(organizationHierarchySubscription);
	}
}
